import type { PublisherKey } from '@planuze/admin-contracts';
import { Card, CardContent, CardHeader, CardTitle, EmptyState, StatusBadge } from '@planuze/ui';
import { KeyRoundIcon } from 'lucide-react';
import { usePublishersContent } from '../../content/sections/publishers.js';

/* Chaves Ed25519 do publisher (ADR-0476/0405): fingerprint + root-signed + revogada. Read-only —
   a rotação/retire é o portal do publisher (PUB-18/28), não o backoffice. */
export function PublisherKeysCard({ keys }: { readonly keys: readonly PublisherKey[] }) {
  const copy = usePublishersContent();
  return (
    <Card>
      <CardHeader>
        <CardTitle>{copy.keysCard.title}</CardTitle>
      </CardHeader>
      <CardContent>
        {keys.length === 0 ? (
          <EmptyState
            icon={<KeyRoundIcon className="size-6" />}
            title={copy.keysCard.emptyTitle}
            description={copy.keysCard.emptyDescription}
          />
        ) : (
          <ul className="space-y-2">
            {keys.map((key) => (
              <li
                key={key.id}
                className="flex flex-wrap items-center justify-between gap-2 rounded-md border border-border bg-card px-3 py-2"
              >
                <span className="font-mono text-xs text-muted-foreground">{key.fingerprint}</span>
                <span className="flex items-center gap-2">
                  <StatusBadge variant={key.rootSigned ? 'success' : 'warning'} dot>
                    {key.rootSigned ? copy.keysCard.rootSigned : copy.keysCard.awaitingRootSign}
                  </StatusBadge>
                  {key.revoked && (
                    <StatusBadge variant="destructive">{copy.keysCard.revoked}</StatusBadge>
                  )}
                </span>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
